declare let ScrollMagic: any;
import {
    fadeInLeftOnEnterAnimation,
    fadeInRightOnEnterAnimation,
    fadeOutLeftOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-flex-steps',
    templateUrl: './block-flex-steps.component.html',
    animations: [
        fadeInRightOnEnterAnimation(),
        fadeOutRightOnLeaveAnimation(),
        fadeInLeftOnEnterAnimation(),
        fadeOutLeftOnLeaveAnimation()
    ]
})

export class BlockFlexStepsComponent extends BlockAbstractComponent implements OnInit, AfterViewInit {
    ctrl = new ScrollMagic.Controller();
    contentLoaded: any[] = [];

    ngAfterViewInit() {
        this.animateSteps();
    }

    animateSteps() {
        this.block.content.forEach((item, index) => {
            this.contentLoaded[index + 1] = false;

            new ScrollMagic.Scene({triggerElement: '#box-' + (index + 1)})
                .triggerHook(this.block.data.animationTriggerPoint)
                .setClassToggle('.box-' + (index + 1), 'stepactive')
                .on('start', () => {
                    this.contentLoaded[index + 1] = true;
                })
                .on('leave', () => {
                    this.contentLoaded[index + 1] = false;
                })
                .addTo(this.ctrl);
        });
    }
}
